import store from "../../redux/store";

const checkLocalstorage = function checkLocalstorage(key = store.getState().cookieName) {
    try {
        return localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

export default checkLocalstorage;